import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalFooter } from "reactstrap";
import OutlookLogoSrc from "../../../../assets/icons/ms-outlook.svg";
import { sendGetRequest } from "../../../../actions/app-actions";
import { getCalendarBusinessId } from "../../../../utils/authHelper";
import { connect } from "react-redux";
import { notification } from "../../../../utils/utility";

const OutlookCheckForConflictModal = (props) => {
  const { data, showConflictModal, hideConflictModal, sendGetRequest, setIsLoading } = props;
  const [calendars, setCalendars] = useState([]);
  const [selectedCalendars, setSelectedCalendars] = useState(() => {
    try { return JSON.parse(data?.selected_calendars) || []; } catch { return []; }
  });

  useEffect(() => {
    setIsLoading(true);
    sendGetRequest({
      url: `/outlook-list-calendars/${data?.id}/${getCalendarBusinessId()}`,
      onSuccess: (response) => {
        setCalendars(response.calendars || []);
        setIsLoading(false);
      },
      onError: () => setIsLoading(false),
    });
  }, []);

  const onCalendarTickChange = (browserEvent, cal) => {
    const selectedCals = [...selectedCalendars];
    const found = selectedCals.some((c) => c?.id === cal?.id);
    if (browserEvent.target.checked) {
      if (!found) setSelectedCalendars([...selectedCals, cal]);
    } else {
      if (found)
        setSelectedCalendars(selectedCals.filter((c) => c?.id !== cal.id));
    }
  };

  const onUpdate = () => {
    if (selectedCalendars.length === 0)
      return notification.error("Please select at least one calendar");
    if (selectedCalendars.length > 4)
      return notification.error("You can't select more than 4 calendars");
    props.onUpdateCheckForConflictCals(selectedCalendars);
  };

  const email = (() => {
    try { return JSON.parse(data?.meta_data)?.email || ""; } catch { return ""; }
  })();

  return (
    <Modal
      className="ci-popup-modal"
      isOpen={showConflictModal}
      toggle={hideConflictModal}
      centered
    >
      <ModalBody>
        {/* Header */}
        <div className="ci-popup-head">
          <h2>Check for conflicts</h2>
          <button
            className="ci-popup-close"
            onClick={hideConflictModal}
            aria-label="Close"
          >
            ×
          </button>
        </div>

        {/* Account pill */}
        <div className="ci-popup-account">
          <div className="ci-popup-account__logo">
            <img src={OutlookLogoSrc} alt="Microsoft Outlook" />
          </div>
          <span className="ci-popup-account__email">{email}</span>
        </div>

        {/* Calendar list */}
        <div className="ci-popup-section">
          <h4>Select calendars to check</h4>
          {calendars.map((cal, index) => (
            <div className="ci-check-row" key={cal?.id || index}>
              <input
                id={`outlook-cal-${index}`}
                type="checkbox"
                value={cal?.id}
                onChange={(e) => onCalendarTickChange(e, cal)}
                checked={selectedCalendars.some((sc) => sc?.id === cal?.id)}
              />
              <label htmlFor={`outlook-cal-${index}`}>{cal?.summary}</label>
            </div>
          ))}
        </div>
      </ModalBody>

      <ModalFooter>
        <button className="ci-popup-btn-cancel" onClick={hideConflictModal}>
          Cancel
        </button>
        <button className="ci-popup-btn-primary" onClick={onUpdate}>
          Save changes
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default connect(null, { sendGetRequest })(OutlookCheckForConflictModal);
